import Actions from 'actions';
import { useEffect } from 'react';

export const Redirect = (props: Parameters<typeof Actions.navigate.replace>[0]) => {
  useEffect(() => Actions.navigate.replace(props));
  return null;
};
